module.exports = __webpack_public_path__ + "static/media/Become-a-partner.910ac21e.jpg";